var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('customers-app-users-create',{attrs:{"after-creation-forwarding-url":"/appusers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }